module.exports = __webpack_public_path__ + "media/images/credit-card-logo/jcb-d80f28eb247ab235f4cc1fe41b3a6106.svg";